import {LocationInterface} from "@/shared/interfaces/LocationInterface";
import {FilterInterface} from "@/MarketSearch/interfaces/FilterInterface";

type ValidPropertyOfLocation =
    'name'
    | 'city'
    | 'addressExtra'
    | 'streetAndNumber'
    | 'zip'
    | 'phone'
    | 'email'
    | 'website'
    | 'province'
    | 'descriptionShort'
    | 'descriptionLong';

export class LocationFilter {

    private compare(location: LocationInterface, name: ValidPropertyOfLocation, searchTerm: string) {
        const value = location[name];
        if (!value) return false;
        return (value.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
    }

    findInList(stringArray: string[] | undefined, value: string): boolean {
        if (typeof stringArray === 'undefined') return false;
        return !!(stringArray.find(service => service.indexOf(value.toLowerCase()) > -1));
    }

    findInPropertyList(propList: ValidPropertyOfLocation[], location: LocationInterface, searchTerm: string): boolean {
        for (let i = 0; i < propList.length; i++) {
            if (this.compare(location, propList[i], searchTerm.toLowerCase())) {
                return true;
            }
        }
        return false;
    }

    private filterBySearchTerm(locationList: Set<LocationInterface>, searchTerm: string) {
        if (searchTerm === '') return locationList;

        const result = new Set<LocationInterface>();
        const testingStringProperties: ValidPropertyOfLocation[] = [
            'name', 'city', 'addressExtra', 'streetAndNumber',
            'zip', 'phone', 'email', 'website',
            'province',
        ];

        locationList.forEach(location => {
            if (
                this.findInPropertyList(testingStringProperties, location, searchTerm)
                || this.findInList(location.services, searchTerm)
                || this.findInList(location.keywords?.keywords, searchTerm)
            ) {
                result.add(location);
                return;
            }
        });

        return result;
    }

    private filterByFilter(locationList: Set<LocationInterface>, activeFilters: Set<FilterInterface>, activeFeatures: Set<FilterInterface>): Set<LocationInterface> {
        if (activeFilters.size === 0 && activeFeatures.size === 0) return locationList;

        const activeLocationTypes = new Set<string>();
        const activeFeaturesTypes = new Set<string>();
        let result = Array.from(locationList);

        activeFilters.forEach(filter => {
            activeLocationTypes.add(filter.type);
        });

        activeFeatures.forEach(feature => {
            activeFeaturesTypes.add(feature.type);
        });

        if (activeLocationTypes.size > 0) {
            result = result.filter(location => activeLocationTypes.has(location.keywords.locationType))
        }

        if (activeFeaturesTypes.size > 0) {
            result = result.filter(location =>
                location.keywords.featureTypes.find(
                    features => activeFeaturesTypes.has(features)
                )
            );
        }

        return new Set(result);
    }

    public filter(locationList: Set<LocationInterface>, searchTerm: string, activeFilters: Set<FilterInterface>, activeFeatures: Set<FilterInterface>): Set<LocationInterface> {
        if (searchTerm === '' && activeFilters.size === 0 && activeFeatures.size === 0) return locationList;

        locationList = this.filterBySearchTerm(locationList, searchTerm);
        return this.filterByFilter(locationList, activeFilters, activeFeatures); // <-- todo: bugfix: funktioniert nur 1x
    }
}
